import ConfirmationModal from '../ui-components/ConfirmationModal'
import InputGroup from '../ui-components/InputGroup'
import ButtonControl from '../button-control'
import ZendeskLogo from './assets/zendeskLogo.js'
import Flag from '../ui-components/Flag'
import Panel from '../panel'
import globals from '../../utils/globals'

const Zendesk = (props) => {
  const { apiToken, subdomain, agentEmail, isInstalled, apiTokenError, subdomainError, agentEmailError, showConfirmationMessage } = props.data
  const isFederatedSearchEnabled = (globals('activeModules') || []).indexOf('federatedSearch') !== -1

  const getDeleteConfirmationButtons = () => {
    return [
      {
        text: 'Confirm',
        class: 'btn btn-danger qa-confirm',
        showLoading: false,
        callback: props.onDelete
      },
      {
        text: 'Cancel',
        class: 'btn btn-default',
        showLoading: false,
        callback: props.onHideConfirmationMessage
      }
    ]
  }

  const headerHTML = () => (
    <div>
      <div class='integrations-zendesk__logo'>
        <ZendeskLogo />
      </div>
      <div class='integrations-zendesk__panel-heading-wrapper'>
        <h3 class='integrations-zendesk__panel-heading'>Zendesk Support</h3>
        <p class='integrations-zendesk__panel-subheading'>Create Zendesk tickets from community posts.</p>
      </div>
      {isInstalled ? <Flag text='Installed' success /> : null}
    </div>
  )

  return (
    <Panel title={headerHTML()}>
      {
        isFederatedSearchEnabled ? <ButtonControl disabled={!isInstalled} variant='primary' title='Sync' onClick={props.onSync} /> : null
      }
      <InputGroup title='API token *'
        type='text'
        required
        qaClasses='qa-api-token-input'
        disabled={isInstalled}
        value={apiToken}
        onChange={props.onApiTokenChanged}
        error={apiTokenError} />
      <div class='integrations-zendesk__domain-wrapper'>
        <div class={`integrations-zendesk__domain ${isInstalled ? 'integrations-zendesk__domain--disabled' : ''} ${subdomainError ? 'integrations-zendesk__domain--error' : ''}`}>
          .zendesk.com
        </div>
        <span class='integrations-zendesk__domain-input'>
          <InputGroup title='Subdomain *'
            type='text'
            required
            qaClasses='qa-subdomain-input'
            disabled={isInstalled}
            value={subdomain}
            onChange={props.onSubdomainChanged}
            error={subdomainError} />
        </span>
      </div>
      <InputGroup title='Agent Email *'
        type='email'
        required
        qaClasses='qa-agent-email-input'
        disabled={isInstalled}
        value={agentEmail}
        onChange={props.onAgentEmailChanged}
        error={agentEmailError} />
      {isInstalled
        ? <ButtonControl variant='warning' class={'qa-delete'} title='Uninstall and delete credentials' onClick={props.onShowConfirmationMessage} />
        : <ButtonControl variant='primary' title='Install' class={'qa-submit'} onClick={props.onInstall} />
      }
      <ConfirmationModal
        enableModal={showConfirmationMessage}
        title='Uninstall and delete credentials?'
        message='Your team will no longer be able to create Zendesk tickets from community posts. Posts that were already escalated will still show links to the ticket.'
        buttons={getDeleteConfirmationButtons()}
        onClose={props.onHideConfirmationMessage}
      />
    </Panel>
  )
}

export default Zendesk
